import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Helper } from 'src/app/helper/defult';
import { HttpIOService } from 'src/app/services/http-io.service';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PopupConfirmationComponent } from 'src/app/container/elements/popup-confirmation/popup-confirmation.component';
import { DynamicSnacbarErrorComponent } from 'src/app/container/elements/dynamic-snacbar-error/dynamic-snacbar-error.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
@Component({
  selector: 'app-workforce-manage',
  templateUrl: './workforce-manage.component.html',
  styleUrls: ['./workforce-manage.component.scss']
})
export class WorkforceManageComponent implements OnInit {
  stars = Array(5).fill(0);
  userDetailsForm: FormGroup;
  emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9_.+-]{2,}$/;
  namePattern = /^[A-Za-z]+(?: [A-Za-z]+)*$/;
  numberPattern = /^\+?\d+$/;
  showTYpage: boolean = false;

  // Employers logos list
  logos = [
    '../../../../assets/images/tbo-logo.webp',
    '../../../../assets/images/zedcrest-logo.webp',
    '../../../../assets/images/aim-logo.webp',
    '../../../../assets/images/pecan-logo.webp',
    '../../../../assets/images/routelink-logo.webp',
    '../../../../assets/images/qlc-logo.webp',
    '../../../../assets/images/magna-logo.webp',
    '../../../../assets/images/manna-logo.webp',
    '../../../../assets/images/fohat-logo.webp',
    '../../../../assets/images/arise-logo.webp',
    '../../../../assets/images/richway-logo.webp',
    '../../../../assets/images/platview-logo.webp',
    '../../../../assets/images/cochlear-logo.webp',
    '../../../../assets/images/gosolve-logo.webp',
  ]

  // Build Workforce Cards Data
  build_wf = [
    {
      photo: '../../../../assets/images/single-person.webp',
      title: 'Executive Recruitment',
      para: 'High-level leadership talent to drive success.',
    },
    {
      photo: '../../../../assets/images/plural-persons.webp',
      title: 'Mass Recruitment',
      para: 'Scale your team quickly with top candidates.',
    },
    {
      photo: '../../../../assets/images/calendar-green.webp',
      title: 'Contract Staffing & more',
      para: 'Efficient short-term project hires.',
    },
  ]

  // Reliable Outsourcing Cards Data 
  reliable_os = [
    {
      photo: '../../../../assets/images/orange-clock.webp',
      title: 'Temporary Staffing',
      para: 'Fast hires for urgent roles.',
    },
    {
      photo: '../../../../assets/images/orange-single-person.webp',
      title: 'Permanent Placement',
      para: 'Long-term hires to strengthen your core team.',
    },
    {
      photo: '../../../../assets/images/orange-doc.webp',
      title: 'Payroll & HR Outsourcing',
      para: 'We take care of all your HR functions and compliance.',
    },
  ]

  // Why WorkNigeria Cards Data
  why_wn = [
    {
      photo: '../../../../assets/images/green-clock-2.webp',
      title: 'Quick Turnaround',
      para: 'Get qualified candidates in 3–5 working days.',
    },
    {
      photo: '../../../../assets/images/green-signals.webp',
      title: 'Industry Expertise',
      para: 'Proven success across multiple sectors.',
    },
    {
      photo: '../../../../assets/images/green-settings.webp',
      title: 'Tailored Solutions',
      para: 'Customized recruitment and outsourcing for your unique needs.',
    },
    {
      photo: '../../../../assets/images/green-shield.webp',
      title: 'Compliance Covered',
      para: 'We manage all legal and regulatory requirements.',
    },
    {
      photo: '../../../../assets/images/green-dollar.webp',
      title: 'Cost-Effective',
      para: 'Save time and reduce overhead while growing your business.',
    },
  ]

  // The clients saying Data
  client_words = [
    {
      quote: '"WorkNigeria provided exceptional recruitment services for our senior roles, and we couldn\'\t satisfied with the results. They demonstrated a deep understanding of our company\'\s needs and took the time to find candidates who not only had the right skills but also aligned with our organizational culture."',
      f_name: 'Rafiat',
      company: 'TA Team, Rite Food'
    },
    {
      quote: '"WorkNigeria exceeded our expectations in recruiting top-notch middle-level talent for our company. Their expertise, thorough screening process, and understanding of our needs ensured we hired highly skilled professionals. The candidates are a perfect fit, contributing immediately to our success."',
      f_name: 'Jonathan',
      company: 'HR Manager, Bridgehead Engineering'
    },
    {
      quote: '"WorkNigeria did an amazing job handling our bulk recruitment. Efficient, professional, and found great talent quickly. Highly recommended!"',
      f_name: 'Kenneth',
      company: 'Head of HR, Activedge Technologies'
    },
    {
      quote: '"WorkNigeria has been fantastic in recruiting engineers for Textron Engineering. Their professionalism and attention to detail are impressive!"',
      f_name: 'Joseph',
      company: 'MD/CEO, Textron Engineering'
    },
  ]

  constructor(
    private fb: FormBuilder,
    private helper: Helper,
    private io: HttpIOService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    this.userDetailsForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.pattern(this.namePattern)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      phoneNumber: ['', [Validators.required, Validators.pattern(this.numberPattern)]],
      path: ['/brochure-email', Validators.required],
      type: ['workforce', Validators.required]
    });
  }

  get f() {
    return this.userDetailsForm.controls;
  }

  scrollToForm() {
    const element = <HTMLElement>document.querySelector(`#simpleForm`);
    element.scrollIntoView({ behavior: 'smooth' });
  }


  submitForm() {
    if (this.userDetailsForm.status === 'INVALID') {
      this.helper.markFormGroupTouched(this.userDetailsForm);
      return false;
    }
    this.showTYpage = !this.showTYpage;
    this.io._saveUserData(this.userDetailsForm.value).subscribe((res: any) => {
      if (res.serverResponse.code == 200) {
        let successData = 'workforce manage confirms';
        this.router.navigate(['/form-submitted']);
      } else {
        this.snackBar
          .openFromComponent(DynamicSnacbarErrorComponent, {
            data: res.serverResponse.message,
            verticalPosition: 'top', // 'top' | 'bottom'
            horizontalPosition: 'right', //'start' | 'center' | 'end' | 'left' | 'right'
          })
          .afterOpened()
          .subscribe(this.helper.setOnTop);
      }
    })
  }
}
